var map = {
	"./nav-list.de-CH.json": 1040,
	"./nav-list.de-DE.json": 1041,
	"./nav-list.en-CA.json": 1042,
	"./nav-list.en-GB.json": 1043,
	"./nav-list.en-IN.json": 1044,
	"./nav-list.en-ME.json": 1045,
	"./nav-list.en-US.json": 1046,
	"./nav-list.es-EM.json": 1047,
	"./nav-list.es-ES.json": 1048,
	"./nav-list.fr-BE.json": 1049,
	"./nav-list.fr-CA.json": 1050,
	"./nav-list.fr-CH.json": 1051,
	"./nav-list.nl-BE.json": 1052,
	"./nav-list.nl-NL.json": 1053,
	"./nav-list.pl-PL.json": 1054,
	"./nav-list.pt-BR.json": 1055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1039;